<template>
    <div class="table-container">
        <div class="filter-container ml-2 mt-2">
                <validated-date-picker
                    format="DD-MM-YYYY"
                    :clearable="true"
                    v-model="vaccination_date"
                    label="Vaccination Date"
                    class="c-input-datepicker">
                </validated-date-picker>
        </div>
        <vue-table ref="table1" :fields="fields" :url="vaccineListURL" :per-page="10" :show-search-box="false" :extra-params="{ vaccination_date: vaccination_date }">
            <template slot="actions" slot-scope="props">
                <div class="btn-group" v-if="currentUser.admin && props.rowData.is_latest">
                    <btn v-if="props.rowData.delete_flag !== true && props.rowData.delete_flag !== 'true'" text="Edit" size="xs" icon="fa fa-pencil" color="primary"
                         @click="editVaccination(props.rowData)"/>
                </div>
            </template>
        </vue-table>
        <div>
            <modal title="Edit Details" ref="vaccEdit" :no-close-on-backdrop="true" width="40r" header-color="primary">
                <VaccinationEdit :data={...editingVaccination} :id=id :animal="animal" @success="formSuccess"></VaccinationEdit>
            </modal>
        </div>
    </div>
</template>

<script>
import urls from '../../../data/urls';
import { mapGetters } from 'vuex';
import VaccinationEdit from '../details-page/EditModals/VaccinationEdit.vue';

export default {
    name: 'CowVaccination',
    components: { VaccinationEdit },
    computed: {
        ...mapGetters(['currentUser']),
        vaccineListURL () {
            const cowID = this.$route.params.id;

            return urls.cowDetailEdit.vaccineInfo + '?id=' + cowID;
        }
    },

    data () {
        return {
            animal: 'cow',
            id: '',
            vaccination_date: '',
            editingVaccination: [],
            fields: [
                {
                    name: 'vaccination_date',
                    title: 'Vaccination Date',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0'
                },
                {
                    name: 'vaccination_type',
                    title: 'Type',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0'
                },
                {
                    name: 'vaccination_name',
                    title: 'Name',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0 text-break'
                },
                {
                    name: 'vaccination_batch_no',
                    title: 'Vaccine Batch No',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0'
                },
                {
                    name: 'next_due_date',
                    title: 'Next DueDate',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0'
                },
                {
                    name: 'remarks',
                    title: 'Remarks',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0 text-break'
                },
                {
                    name: '__slot:actions',
                    title: 'Actions',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 my-3 w-15r b-unset fs-lg-0 text-break'
                }
            ],
            loading: false
        };
    },

    mounted () {
        this.id = this.$route.params.id;
    },
    methods: {
        formSuccess (modal) {
            if (modal === 'vaccination') {
                this.$refs.vaccEdit.close();
                this.$refs.table1.refreshTable();
            }
        },
        editVaccination (item) {
            console.log('editItem:editVaccination: ', item);
            this.editingVaccination = [];
            this.editingVaccination = item;
            this.id = item.cow_id || this.$route.params.id;
            this.$refs.vaccEdit.show();
        }
    }
};
</script>

<style scoped>
.table-container {
        background-color: #fff;
        border-radius: 12px;
        padding: 10px;
    }

    .filter-container {
        width: 200px;
    }
</style>
